// recaptcha.service.ts
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { RecaptchaModalComponent } from '../shared/re-capacha/re-capacha.component';

interface RecaptchaModalConfig {
  autoClose?: boolean;
  autoCloseDelay?: number;
  siteKey?: string;
}

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {
  constructor(private dialog: MatDialog) {}

  // Show reCAPTCHA v2 modal - always shows fresh verification
  async showCaptchaModal(config?: RecaptchaModalConfig): Promise<string | null> {
    // Default configuration
    const modalConfig = {
      autoClose: true,
      autoCloseDelay: 500,
      ...config
    };

    const dialogRef = this.dialog.open(RecaptchaModalComponent, {
      width: '450px',
      disableClose: true,
      panelClass: 'recaptcha-dialog',
      data: modalConfig
    });
    
    const result = await firstValueFrom(dialogRef.afterClosed());
    
    if (result?.token) {
      return result.token;
    }
    
    return null;
  }

  // Removed all caching-related methods since token is one-time use only
}